var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { StepIcon } from './StepIcon';
import useStyle from './HorizontalStepStyles';
var HorizontalStep = function (_a) {
    var index = _a.index, isCurrentStep = _a.isCurrentStep, _b = _a.isFirst, isFirst = _b === void 0 ? false : _b, _c = _a.isLast, isLast = _c === void 0 ? false : _c, isRtl = _a.isRtl, name = _a.name, onClick = _a.onClick, generateLabel = _a.generateLabel, showStepNumber = _a.showStepNumber, status = _a.status, subHeading = _a.subHeading, disabled = _a.disabled;
    var _d = __read(useState(false), 2), hover = _d[0], setHover = _d[1];
    var _e = useStyle({
        isRtl: isRtl,
        isCurrentStep: isCurrentStep,
        status: status,
        hover: hover,
        isFirst: isFirst,
        isLast: isLast,
        subHeading: subHeading
    }), main = _e.main, stepName = _e.stepName, progressBarContainer = _e.progressBarContainer, progressBarLeft = _e.progressBarLeft, progressBarRight = _e.progressBarRight, stepStatus = _e.stepStatus, subHeadingWrapper = _e.subHeadingWrapper;
    var SubHeadingSection = function () {
        if (subHeading) {
            return _jsx("div", __assign({ css: subHeadingWrapper }, { children: subHeading }), void 0);
        }
        return null;
    };
    return (_jsxs("button", __assign({ type: "button", onClick: onClick, disabled: disabled, "aria-label": generateLabel &&
            generateLabel({
                status: status,
                isCurrentStep: isCurrentStep,
                isRtl: isRtl,
                name: name,
                disabled: disabled,
                index: index,
                showStepNumber: showStepNumber
            }), css: main, onMouseEnter: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); } }, { children: [_jsxs("div", __assign({ css: progressBarContainer }, { children: [_jsx("div", { css: progressBarLeft }, void 0),
                    _jsx("div", __assign({ css: stepStatus }, { children: _jsx(StepIcon, { status: status, hover: hover, showStepNumber: showStepNumber, index: index, isSelected: isCurrentStep }, void 0) }), void 0),
                    _jsx("div", { css: progressBarRight }, void 0)] }), void 0),
            _jsx("p", __assign({ css: stepName }, { children: name }), void 0),
            _jsx(SubHeadingSection, {}, void 0)] }), void 0));
};
export default HorizontalStep;
